import {
    ADD_CALENDAR_SESSION,
    ADD_PAPER_TO_UNASSIGNED,
    ADD_ROOM,
    ADD_SESSION,
    ADD_TO_UNASSIGNED,
    CHANGE_SELECTED_DAY,
    DELETE_CALENDAR_SESSION,
    DELETE_CALENDAR_SESSION_BY_SESSION_ID,
    DELETE_ROOM,
    DELETE_SESSION,
    LOAD_CALENDAR,
    LOAD_PAPERS,
    LOAD_SESSIONS,
    LOGIN_REQUESTED,
    LOGIN_SUCCEEDED,
    REMOVE_FROM_UNASSIGNED,
    REMOVE_PAPER_FROM_UNASSIGNED,
    SET_ARE_PAPERS_LOADED,
    UPDATE_CALENDAR_SESSION,
    UPDATE_ROOM,
    UPDATE_SESSION,
    CHANGE_SESSION_COLOR,
} from "./actionTypes";

/* Auth */
export const login = (formData, from) => ({
    type: LOGIN_REQUESTED,
    payload: {
        formData,
        from,
    },
});

export const loginSucceeded = (user, from) => ({
    type: LOGIN_SUCCEEDED,
    payload: {
        user,
        from,
    },
});

/* Papers */
export const loadPapers = (papers) => ({
    type: LOAD_PAPERS,
    payload: {
        papers,
    },
});

export const removePaperFromUnassigned = (paperId) => ({
    type: REMOVE_PAPER_FROM_UNASSIGNED,
    payload: {
        paperId,
    },
});

export const addPaperToUnassigned = (paper) => ({
    type: ADD_PAPER_TO_UNASSIGNED,
    payload: {
        paper,
    },
});

export const setArePapersLoaded = (value) => ({
    type: SET_ARE_PAPERS_LOADED,
    payload: {
        value,
    },
});

/* Sessions */
export const addSession = (session) => ({
    type: ADD_SESSION,
    payload: {
        session,
    },
});

export const loadSessions = (sessionTypes, sessions, unAssignedSessions) => ({
    type: LOAD_SESSIONS,
    payload: {
        sessionTypes,
        sessions,
        unAssignedSessions,
    },
});

export const addToUnassigned = (sessions) => ({
    type: ADD_TO_UNASSIGNED,
    payload: {
        sessions,
    },
});

export const removeFromUnassigned = (sessionId) => ({
    type: REMOVE_FROM_UNASSIGNED,
    payload: {
        sessionId,
    },
});

export const updateSession = (sessionId, session) => ({
    type: UPDATE_SESSION,
    payload: {
        sessionId,
        session,
    },
});

export const deleteSession = (sessionId) => ({
    type: DELETE_SESSION,
    payload: {
        sessionId,
    },
});

/* Rooms */
export const addRoom = (room) => ({
    type: ADD_ROOM,
    payload: {
        room,
    },
});

export const updateRoom = (roomId, room) => ({
    type: UPDATE_ROOM,
    payload: {
        roomId,
        room,
    },
});

export const deleteRoom = (roomId) => ({
    type: DELETE_ROOM,
    payload: {
        roomId,
    },
});

/* Sessions */
export const loadCalendar = (conferenceDates, calendarData, roomsData) => ({
    type: LOAD_CALENDAR,
    payload: {
        conferenceDates,
        calendarData,
        roomsData,
    },
});

export const changeSelectedDay = (newDay) => ({
    type: CHANGE_SELECTED_DAY,
    payload: {
        newDay,
    },
});

export const addCalendarSession = (calendarSession) => ({
    type: ADD_CALENDAR_SESSION,
    payload: {
        calendarSession,
    },
});

export const updateCalendarSession = (calendarSessionId, calendarSession) => ({
    type: UPDATE_CALENDAR_SESSION,
    payload: {
        calendarSessionId,
        calendarSession,
    },
});

export const deleteCalendarSession = (calendarSessionId) => ({
    type: DELETE_CALENDAR_SESSION,
    payload: {
        calendarSessionId,
    },
});

export const deleteCalendarSessionBySessionId = (sessionId) => ({
    type: DELETE_CALENDAR_SESSION_BY_SESSION_ID,
    payload: {
        sessionId,
    },
});

export const changeSessionColor = (sessionId, colorPanel) => ({
    type: CHANGE_SESSION_COLOR,
    payload: {
        sessionId,
        colorPanel,
    },
});
